import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  PageListBean,
  RestRoleListRequest,
  RoleSearchCriteria,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { SecurityService } from "../services/SecurityService.js";
export class RoleLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new RoleSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let roleLookupCriteria = new RoleSearchCriteria();
    roleLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = RoleLookupCriteraHandler(
      companyCode,
      roleLookupCriteria
    );
    let newCriteria = new RoleSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(lookupDataCallback, roleLookupCriteria, lookupCriteriaView);
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(
      this.attribute_name + " Name",
      "description",
      0,
      false
    ); //1
  }
  loadRoleList = (lookup_dialog, pageNumber, searchCriteria) => {
    let criteria = new RoleSearchCriteria(); //To be fetched from CriteriaHandler
    criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      criteria.roleCode = searchCriteria.roleCode;
    }
    let pageList = new PageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.currentPage = pageNumber;
    pageList.pageNumber = pageNumber;
    let requestInput = new RestRoleListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    SecurityService.getRolePageList(
      requestInput,
      (response) => this.loadRoleListResponse(response, lookup_dialog),
      this.loadRoleListError
    );
  };
  loadRoleListResponse = (response, lookup_dialog) => {
    let roleList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.rolePageList != null &&
      response.data.rolePageList.users !== null
    ) {
      roleList = response.data.rolePageList.roles;
      totalCount = response.data.rolePageList.totalCount;
      currentPageNumber = response.data.rolePageList.currentPage;
      pageSize = response.data.rolePageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = roleList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadRoleListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.roleCode)) {
      if (!isEmptyString(filterText)) {
        search.roleCode = filterText;
        this.searchCriteria = new RoleSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadRoleList(lookup_dialog, pageNumber, search);
    }
  }
}
const RoleLookupCriteraHandler = (companyCode, roleLookupCriteria) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new RoleSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });

      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new RoleSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>RoleCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  ref={this.focusRef}
                  id="roleCode"
                  name="roleCode"
                  onChange={this.onChange}
                  value={searchCriteria.roleCode}
                />
              </Col>
            </Row>
            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                Continue[/]
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
